import {
  GET_CURRENCIES,
  GET_CURRENCIES_SUCCESS,
  GET_CURRENCIES_FAILURE,
} from "./actionTypes";

const initialState = {
  coupons: [],
  loading: false,
  error: "",
  currencies: [],
};

const stores = (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENCIES:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_CURRENCIES_SUCCESS:
      state = {
        ...state,
        loading: false,
        currencies: action.payload.currencies,
      };
      break;
    case GET_CURRENCIES_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default stores;
